<div class="m-1 mt-2">
    <app-training-item-group-search [feature]="feature" (emitSelectedData)="onSelectionOrDeselection($event)"
    (shouldAddTrainingItemButtonDisplayed)="showOrHideAddButton($event)"
    >
    </app-training-item-group-search>
</div>
<div class="col mb-2 card flex" *ngIf="showAddButton">
    <p-splitButton class="p-splitbutton-menubutton splitBtn" label="Add and Close" (onClick)="addTrainingPlanAndClose()" [model]="items"></p-splitButton>
</div>